/// <reference path="wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        const LOG_CATEGORY = "WPT.Navigation.Logon";
        const QUERYSTRING_ACTIVATION = "showActivate";
        const QUERYSTRING_FORGOT_PW = "forgotPassword";
        const QUERYSTRING_VERIFICATION = "verificationCode";
        const CREATE_WIDGET_NAME = "CreateAccount";
        const DEFAULT_TEMPLATE = 1;
        const DEFAULT_WIDGETS_CONFIG = {
            Login: {
                Instance: [
                    {
                        PlaceHolder: "#loginPlaceholder",
                        CollapseState: "Show",
                        SuppressHeading: true,
                        SuppressBorder: true
                    }
                ]
            },
            LoginExtra: {
                Instance: [
                    {
                        PlaceHolder: "#loginExtraPlaceholder1",
                        CollapseState: "Show"
                    },
                    {
                        PlaceHolder: "#loginExtraPlaceholder2",
                        CollapseState: "Show"
                    },
                    {
                        PlaceHolder: "#loginExtraPlaceholder3",
                        CollapseState: "Show"
                    }
                ]
            },
            CreateAccount: {
                Instance: [
                    {
                        PlaceHolder: "#createAccountPlaceholderTop",
                        CollapseState: "Show"
                    },
                    {
                        PlaceHolder: "#createAccountPlaceholderBottom",
                        CollapseState: "Show"
                    }
                ]
            }
        };
        class LogonNavigationHandler extends Navigation.LogonNavigationHandlerBaseClass {
            constructor(core, navigation) {
                super(core, navigation);
                this._logonPage = null;
                this._modalLogo = null;
                this._userInputContainer = null;
                this._userInput = null;
                this._passwordInputContainer = null;
                this._passwordInput = null;
                this._signInBtn = null;
                this._createAccountBtn = null;
                this._forgotPw = null;
                this._retryConnect = null;
                this._unableToConnect = null;
                this._connectedIcon = null;
                this._disconnectedIcon = null;
                this._closeIcon = null;
                this._failToLogon = null;
                this._failToLogonInfo = null;
                this._processingDiv = null;
                // Password validation support
                this._supportPasswordValidation = false;
                this._userValidationHash = null;
                this._errorMessage = null;
                this._logonModalForm = null;
                this._logonModalCreateAccount = null;
                this._logonModalLblLogon = null;
                this._activateAccountBtn = null;
                this._reenterPwdInput = null;
                this._currentActivationKey = null;
                this._createAccountFormPlaceholder = null;
                this._activeCreateAccount = null;
                this._useModalCreateAccount = null;
                this._alwaysShowCreateAccount = null;
                this._currentForgotPwKey = null;
                this._currentValidationKey = null;
                this._resetForgottenPwBtn = null;
                this._forgotPwBtn = null;
                this._forgotPwUserInput = null;
                this._hideForgotPassword = null;
                // IdP/oidc/SSO support
                this._oidcMgr = null;
                this._usingIdP = false;
                this._modalHtml = null;
                this._activationHtml = null;
                this._resetPwHtml = null;
                this._retainQueryStringAtLogout = true;
                this._forgotPwHtml = null;
                this._currentLogonModalSession = null;
                this._currentForgotPwModalSession = null;
                this._currentActivationModalSession = null;
                this._currentResetPwModalSession = null;
                this.startNavigation = () => {
                    this._log.info("LogonNavigationHandler.startNavigation()");
                    this._logonPage.innerHTML = "";
                    let selectedApp = this._core.Config.getApplicationConfig();
                    if (selectedApp.hasOwnProperty('HideForgotPassword') && selectedApp.HideForgotPassword) {
                        this._hideForgotPassword = true;
                    }
                    else {
                        this._hideForgotPassword = false;
                    }
                    if (selectedApp.hasOwnProperty('CreateAccount') && selectedApp.CreateAccount.hasOwnProperty('Active') && selectedApp.CreateAccount.Active) {
                        this._activeCreateAccount = true;
                        let createAccConf = selectedApp.CreateAccount;
                        if (createAccConf.hasOwnProperty('DisableModalForm') && createAccConf.DisableModalForm) {
                            this._useModalCreateAccount = false;
                            if (createAccConf.hasOwnProperty('AlwaysShowForm') && createAccConf.AlwaysShowForm) {
                                this._alwaysShowCreateAccount = true;
                            }
                            else {
                                this._alwaysShowCreateAccount = false;
                            }
                        }
                        else {
                            this._useModalCreateAccount = true;
                        }
                    }
                    else {
                        this._activeCreateAccount = false;
                    }
                    if (selectedApp.hasOwnProperty('Content') && selectedApp.Content.hasOwnProperty('LoginScreen') && selectedApp.Content.LoginScreen) {
                        let loginScreen = selectedApp.Content.LoginScreen;
                        if (loginScreen.hasOwnProperty('CustomLogonTemplate') && loginScreen.CustomLogonTemplate.trim().length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using custom logon template: " + loginScreen.CustomLogonTemplate);
                            }
                            this._core.Loader.getUnversionedHTML('custom/layouts/logon/' + loginScreen.CustomLogonTemplate + '.html', this._prepareLayout, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            let template = null;
                            if (loginScreen.hasOwnProperty('LogonTemplate')) {
                                template = loginScreen.LogonTemplate;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("using logon template: " + template);
                                }
                            }
                            if (template == null || template == undefined) {
                                template = DEFAULT_TEMPLATE;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("using default logon template: " + template);
                                }
                            }
                            this._core.Loader.getVersionedHTML('layouts/logon/templateLogon' + template + '.html', this._prepareLayout, this._core.Helper.missingHtmlErrorCallback);
                        }
                    }
                    let activationKey = this._core.getQueryStringValue(QUERYSTRING_ACTIVATION);
                    if (activationKey) {
                        // remove activation query string parameter, allow storage of URL for later use
                        this._core.removeQueryString(QUERYSTRING_ACTIVATION);
                    }
                    let verificationKey = this._core.getQueryStringValue(QUERYSTRING_VERIFICATION);
                    if (verificationKey) {
                        // remove activation query string parameter, allow storage of URL for later use
                        this._core.removeQueryString(QUERYSTRING_VERIFICATION);
                    }
                    let forgotPasswordKey = this._core.getQueryStringValue(QUERYSTRING_FORGOT_PW);
                    if (forgotPasswordKey) {
                        // remove forgot password query string parameter, allow storage of URL for later use
                        this._core.removeQueryString(QUERYSTRING_FORGOT_PW);
                    }
                    if (activationKey !== undefined) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got activation key: " + activationKey);
                        }
                        this._currentActivationKey = activationKey;
                        this._presentActivationModal();
                    }
                    else if (forgotPasswordKey !== undefined) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got forgot password key: " + forgotPasswordKey);
                        }
                        this._currentForgotPwKey = forgotPasswordKey;
                        this._presentResetPwModal();
                    }
                    else if (verificationKey !== undefined) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got verification key: " + verificationKey);
                        }
                        this._currentValidationKey = verificationKey;
                        this._startContactVerification();
                    }
                    else if (selectedApp.hasOwnProperty('OpenLogonOnLaunch') && selectedApp.OpenLogonOnLaunch) {
                        this.presentLogonModal();
                    }
                    else if (this.UsingIdP) {
                        // If we have already logged into IdP but OpenLogonOnLaunch is not set, we stall waiting for the button again
                        this._checkIdPLogon(this._idpExecuteOnBaseLoginIfReady.bind(this));
                    }
                };
                this.presentLogonModal = () => {
                    this._log.info("LogonNavigationHandler.presentLogonModal()");
                    // At this point we may need to hijack the login process to redirect to IdP
                    let gwConfig = this._core.Config.getMainConfig();
                    if (gwConfig.hasOwnProperty('IdP') && gwConfig.IdP && gwConfig.IdP.hasOwnProperty('Enabled') && gwConfig.IdP.Enabled) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("IdP Enabled, bypassing directive");
                        }
                        this._checkIdPLogon(this._idpExecuteNextLoginStep.bind(this));
                    }
                    else {
                        let modalSession = 'logon-modal-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                        if (modal !== null && modal !== undefined) {
                            this._currentLogonModalSession = modalSession;
                            if (this._modalHtml === null) {
                                this._core.Loader.getVersionedHTML('assets/wpt/html/LogonModal.html', this._storeModalHtml, this._core.Helper.missingHtmlErrorCallback);
                            }
                            else {
                                this._finishLogonModal();
                            }
                        }
                        else {
                            console.error("unable to show logon modal, modal placeholder is already used");
                        }
                    }
                };
                this.presentForgotPwModal = () => {
                    this._log.info("LogonNavigationHandler.presentForgotPwModal()");
                    let modalSession = 'forgot-pw-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentForgotPwModalSession = modalSession;
                        this._startForgotPwModal();
                    }
                    else {
                        console.error("unable to show forgot password modal, modal placeholder is already used");
                    }
                };
                this._prepareLayout = (htmlData) => {
                    this._log.info("LogonNavigationHandler._prepareLayout()");
                    this._logonPage.innerHTML = htmlData;
                    let selectedApp = this._core.Config.getApplicationConfig();
                    if (this._activeCreateAccount && !this._useModalCreateAccount) {
                        if (selectedApp.CreateAccount.hasOwnProperty('ShowFormAtBottom') && selectedApp.CreateAccount.ShowFormAtBottom) {
                            this._createAccountFormPlaceholder = this._logonPage.querySelector('#createAccountPlaceholderBottom');
                        }
                        else {
                            this._createAccountFormPlaceholder = this._logonPage.querySelector('#createAccountPlaceholderTop');
                        }
                        if (!this._alwaysShowCreateAccount) {
                            this._core.Functions.hideElement(this._createAccountFormPlaceholder);
                        }
                    }
                    let widgetsConfig = DEFAULT_WIDGETS_CONFIG;
                    if (selectedApp.Content.hasOwnProperty('LoginScreen') && selectedApp.Content.LoginScreen != null) {
                        let loginScreen = selectedApp.Content.LoginScreen;
                        if (loginScreen.hasOwnProperty('Widgets') && loginScreen.Widgets != null) {
                            widgetsConfig = loginScreen.Widgets;
                        }
                    }
                    for (let widgetName in widgetsConfig) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at widget: " + widgetName);
                        }
                        let widgetConfig = widgetsConfig[widgetName];
                        this._core.Widgets.createStandaloneWidget(widgetName, Navigation.LOGON_VIEW_NAME, widgetConfig);
                    }
                };
                this._storeModalHtml = (htmlData) => {
                    this._log.info("LogonNavigationHandler._storeModalHtml()");
                    this._modalHtml = htmlData;
                    this._finishLogonModal();
                };
                this._finishLogonModal = () => {
                    this._log.info("LogonNavigationHandler._finishLogonModal()");
                    let modal = this._core.getModal(this._currentLogonModalSession);
                    modal.DIV.innerHTML = this._modalHtml;
                    this._logonModalForm = modal.DIV.querySelector('#logonModalForm');
                    this._logonModalCreateAccount = modal.DIV.querySelector('#logonModalCreateAccount');
                    this._modalLogo = modal.DIV.querySelector('#logonLogo');
                    this._userInputContainer = modal.DIV.querySelector('#usernameTextboxContainer');
                    this._userInput = this._userInputContainer.querySelector('#usernameTextbox');
                    this._passwordInputContainer = modal.DIV.querySelector('#passwordTextboxContainer');
                    this._passwordInput = this._passwordInputContainer.querySelector('#passwordTextbox');
                    this._signInBtn = modal.DIV.querySelector('#signInBtn');
                    this._createAccountBtn = modal.DIV.querySelector('#createAccountBtn');
                    this._forgotPw = modal.DIV.querySelector('#LblForgot');
                    this._retryConnect = modal.DIV.querySelector('#unableToConnectRetry');
                    this._unableToConnect = modal.DIV.querySelector('#unableToConnect');
                    this._connectedIcon = modal.DIV.querySelector('#connectedIcon');
                    this._disconnectedIcon = modal.DIV.querySelector('#disconnectedIcon');
                    this._closeIcon = modal.DIV.querySelector('#closeIcon');
                    this._failToLogon = modal.DIV.querySelector('#failToLogon');
                    this._failToLogonInfo = modal.DIV.querySelector('#failToLogonInfo');
                    this._processingDiv = modal.DIV.querySelector('#processingModelHeading');
                    this._logonModalLblLogon = modal.DIV.querySelector('#LblLogon');
                    this._core.Helper.prepareHourglassIcon(this._processingDiv);
                    let appConfig = this._core.Config.getApplicationConfig();
                    let modalLogoSrc = null;
                    if (appConfig.hasOwnProperty('Images') && appConfig.Images.hasOwnProperty('LogonModalLogo')) {
                        modalLogoSrc = appConfig.Images.LogonModalLogo;
                    }
                    if (modalLogoSrc != null) {
                        this._modalLogo.src = modalLogoSrc;
                        this._core.Functions.showElement(this._modalLogo);
                    }
                    else {
                        this._core.Functions.hideElement(this._modalLogo);
                    }
                    if (this._activeCreateAccount) {
                        this._core.Functions.showElement(this._createAccountBtn);
                        if (this._useModalCreateAccount) {
                            let widgetConfig = {
                                Instance: [
                                    {
                                        PlaceHolder: '#createAccountFormHolder',
                                        CollapseState: 'Show',
                                        SuppressHeading: true,
                                        SuppressBorder: true
                                    }
                                ]
                            };
                            this._core.Widgets.createStandaloneWidget(CREATE_WIDGET_NAME, Navigation.LOGON_VIEW_NAME, widgetConfig);
                        }
                    }
                    else {
                        this._core.Functions.hideElement(this._createAccountBtn);
                    }
                    this._core.Helper.setElementTranslationAttribute(this._userInput, 'placeholder', 'STR_WPT_ENTERUSERNAME');
                    this._core.Helper.setElementTranslationAttribute(this._userInput, 'aria-label', 'STR_WPT_ENTERUSERNAME');
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'placeholder', 'STR_WPT_ENTERPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'aria-label', 'STR_WPT_ENTERPASSWORD');
                    this._core.Helper.setElementTranslation(this._signInBtn.querySelector('#signInBtnLabel'), 'STR_WPT_SIGN_IN');
                    this._core.Helper.setElementTranslation(this._createAccountBtn.querySelector('#createAccountBtnLabel'), 'STR_WPT_CREATEACCOUNT');
                    this._core.Helper.setElementTranslation(this._forgotPw, 'STR_WPT_FORGOTPASSWORD');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#processingLabel'), "STR_WPT_PROCESSING");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#logonModalTitle'), "STR_WPT_LOGON");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#failToLogonLabel'), 'STR_WPT_FAILED_TO_LOGON');
                    this._core.Helper.setElementTranslationAttribute(this._connectedIcon, 'title', "STR_WPT_CONNECTEDVALSERV");
                    let unableToConnect = this._core.Locale.getTranslation("STR_WPT_UNABLELOCSERV");
                    this._disconnectedIcon.setAttribute('title', unableToConnect);
                    modal.DIV.querySelector('#unableToConnectLabel').innerHTML = unableToConnect;
                    this._core.Helper.setElementTranslationAttribute(this._closeIcon, 'title', 'STR_WPT_CLOSE');
                    this._core.Helper.setElementTranslationAttribute(this._closeIcon, 'aria-label', 'STR_WPT_CLOSE');
                    this._core.Helper.setElementTranslation(this._logonModalLblLogon, 'STR_WPT_NO_CREATEACCOUNT');
                    this._failToLogonInfo.addEventListener('click', this._displayLogonErrorMessage);
                    this._forgotPw.addEventListener('click', this._showForgotPw);
                    this._logonModalLblLogon.addEventListener('click', this._switchBackToLogon);
                    modal.DIV.querySelector('#usernameClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._userInput));
                    modal.DIV.querySelector('#passwordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._passwordInput));
                    if (this._hideForgotPassword) {
                        this._core.Functions.hideElement(this._forgotPw);
                    }
                    this._waitForServerPing().then(this._showLogonModal);
                };
                this._waitForServerPing = () => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("LogonNavigationHandler._waitForServerPing()");
                    let counter = 0;
                    while (this._core.getValidServer() == null && counter < WPTNamespace.MAX_SLEEP_INTERVALLS) {
                        counter++;
                        yield this._core.Functions.sleep(500);
                    }
                    if (counter >= WPTNamespace.MAX_SLEEP_INTERVALLS) {
                        console.warn("no basic ping result during " + WPTNamespace.MAX_SLEEP_INTERVALLS + " intervals of waiting, hence aborted...");
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("finished waiting for basic ping result: " + counter);
                    }
                });
                this._showLogonModal = () => {
                    this._log.info("LogonNavigationHandler._showLogonModal()");
                    this._activateLogonModal();
                    this._core.showModal(this._currentLogonModalSession);
                };
                this._activateLogonModal = () => {
                    this._log.info("LogonNavigationHandler._activateLogonModal()");
                    if (this._core.getValidServer() === 'false') {
                        this._core.Functions.hideElement(this._connectedIcon);
                        this._core.Functions.showElement(this._disconnectedIcon);
                        this._prepareLogonModalInput(false);
                        this._core.Functions.showElement(this._unableToConnect);
                        this._retryConnect.addEventListener('click', this._retryServerPing);
                    }
                    else {
                        if (this._core.getValidServer() === 'true') {
                            this._core.Functions.showElement(this._connectedIcon);
                            this._core.Functions.hideElement(this._disconnectedIcon);
                        }
                        else {
                            this._core.Functions.hideElement(this._connectedIcon);
                            this._core.Functions.hideElement(this._disconnectedIcon);
                        }
                        this._prepareLogonModalInput(true);
                        this._core.Functions.hideElement(this._unableToConnect);
                        this._retryConnect.removeEventListener('click', this._retryServerPing);
                        let logon = this;
                        let modal = this._core.getModal(this._currentLogonModalSession);
                        modal.JQ.one('shown.bs.modal', function () {
                            logon._userInput.focus();
                        });
                        this._userInput.focus();
                    }
                };
                this._prepareLogonModalInput = (enable) => {
                    this._log.info("LogonNavigationHandler._prepareLogonModalInput()");
                    this._core.Functions.setInputAbility(this._userInputContainer, enable);
                    this._core.Functions.setInputAbility(this._passwordInputContainer, enable);
                    if (enable) {
                        this._signInBtn.classList.remove(Navigation.DISABLED_CLASS);
                        this._createAccountBtn.classList.remove(Navigation.DISABLED_CLASS);
                        this._userInput.addEventListener('keyup', this._logonKeyup);
                        this._passwordInput.addEventListener('keyup', this._logonKeyup);
                        this._signInBtn.addEventListener('click', this._doLogon);
                        this._createAccountBtn.addEventListener('click', this._createAccount);
                    }
                    else {
                        this._signInBtn.classList.add(Navigation.DISABLED_CLASS);
                        this._createAccountBtn.classList.add(Navigation.DISABLED_CLASS);
                        this._userInput.removeEventListener('keyup', this._logonKeyup);
                        this._passwordInput.removeEventListener('keyup', this._logonKeyup);
                        this._signInBtn.removeEventListener('click', this._doLogon);
                        this._createAccountBtn.removeEventListener('click', this._createAccount);
                    }
                };
                this._logonKeyup = (event) => {
                    this._log.info("LogonNavigationHandler._logonKeyup()");
                    if (event.key === "Enter") {
                        this._doLogon();
                    }
                };
                this._retryServerPing = () => {
                    this._log.info("LogonNavigationHandler._retryServerPing()");
                    this._core.testServerPing();
                    this._waitForServerPing().then(this._activateLogonModal);
                };
                this._doLogon = (event = null) => {
                    this._log.info("LogonNavigationHandler._doLogon()");
                    if (event)
                        event.preventDefault(); // prevent sending of form (would reload the page)
                    let username = this._userInput.value;
                    let password = this._passwordInput.value;
                    if (username === '') {
                        this._userInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._userInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (password === '') {
                        this._passwordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._passwordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (username != '' && password != '') {
                        this._prepareLogonModalInput(false);
                        this._core.Functions.hideElement(this._failToLogon);
                        this._core.Functions.showElement(this._processingDiv);
                        this._core.logon(username, password, this._successfulLogon, this._errorLogon, this._failedLogon);
                    }
                };
                this._showForgotPw = () => {
                    this._log.info("LogonNavigationHandler._showForgotPw()");
                    let logon = this;
                    let modal = logon._core.getModal(logon._currentLogonModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        logon.presentForgotPwModal();
                    });
                    logon._core.hideModal(logon._currentLogonModalSession);
                };
                this._switchBackToLogon = () => {
                    this._log.info("LogonNavigationHandler._switchBackToLogon()");
                    this._core.Functions.hideElement(this._logonModalCreateAccount);
                    this._core.Functions.showElement(this._logonModalForm);
                };
                this._createAccount = (event = null) => {
                    this._log.info("LogonNavigationHandler._createAccount()");
                    if (event)
                        event.preventDefault(); // prevent sending of form (would reload the page)
                    this._core.Functions.clearInputElement(this._userInput);
                    this._core.Functions.clearInputElement(this._passwordInput);
                    if (this._useModalCreateAccount) {
                        this._core.Functions.hideElement(this._logonModalForm);
                        this._core.Functions.showElement(this._logonModalCreateAccount);
                    }
                    else if (!this._alwaysShowCreateAccount) {
                        this._core.Functions.showElement(this._createAccountFormPlaceholder);
                        this._core.hideModal(this._currentLogonModalSession);
                        this._createAccountFormPlaceholder.scrollIntoView();
                    }
                    else {
                        this._core.hideModal(this._currentLogonModalSession);
                        this._createAccountFormPlaceholder.scrollIntoView();
                    }
                };
                this._hideLoader = () => {
                    this._log.info("LogonNavigationHandler._hideLoader()");
                    this._core.Functions.hideElement(this._processingDiv);
                };
                this.submittedCreateAccount = () => {
                    this._log.info("LogonNavigationHandler.submittedCreateAccount()");
                    if (this._useModalCreateAccount) {
                        let logon = this;
                        let modal = logon._core.getModal(logon._currentLogonModalSession);
                        modal.JQ.one('hidden.bs.modal', function () {
                            logon._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_REGISTRATIONSUCCESS');
                        });
                        this._core.hideModal(this._currentLogonModalSession);
                    }
                    else if (!this._alwaysShowCreateAccount) {
                        this._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_REGISTRATIONSUCCESS');
                        this._core.Functions.hideElement(this._createAccountFormPlaceholder);
                    }
                    else {
                        this._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_REGISTRATIONSUCCESS');
                    }
                };
                this._successfulLogon = () => {
                    this._log.info("LogonNavigationHandler._successfulLogon()");
                    if (this._supportPasswordValidation) {
                        if (this._usingIdP) {
                            console.warn("IdP single sign-on is enabled, password verification cannot be supported in this configuration.");
                            this._supportPasswordValidation = false;
                        }
                        else {
                            let hashInput = `${this._passwordInput.value}%${this._core.getCurrentConnectionId()}`;
                            this._userValidationHash = window.hex_sha512(hashInput);
                        }
                    }
                    if (this._usingIdP) {
                        this._core.Helper.closeIdPBusyModal();
                    }
                    else {
                        if (this._userInput) {
                            this._core.Functions.clearInputElement(this._userInput);
                        }
                        this._core.Functions.clearInputElement(this._passwordInput);
                        this._core.Functions.hideElement(this._processingDiv);
                        this._core.hideModal(this._currentLogonModalSession);
                    }
                    let needsUpdate = this._nav.Menu.updateApplications(false, true);
                    if (!needsUpdate) {
                        this._nav.Menu.startApplicationView();
                    }
                };
                this._errorLogon = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._errorLogon()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_LOGON_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    if (this._usingIdP) {
                        let warningFn = this._core.Helper.presentWarningServiceModal.bind(this, "STR_WPT_LOGON", "STR_WPT_ERROR", this._errorMessage, this.idpLogout);
                        this._core.Helper.closeIdPBusyModal(warningFn);
                    }
                    else {
                        this._core.Functions.hideElement(this._processingDiv);
                        this._core.Functions.hideElement(this._failToLogonInfo);
                        this._core.Functions.showElement(this._failToLogon);
                        this._core.Helper.presentWarningServiceModal("STR_WPT_LOGON", "STR_WPT_ERROR", msgBody);
                        this._prepareLogonModalInput(true);
                    }
                };
                this._failedLogon = (data) => {
                    this._log.info("LogonNavigationHandler._failedLogon()");
                    if (data.hasOwnProperty('Connection') && data.Connection.hasOwnProperty('Message')) {
                        let msgPrefix = this._core.Locale.getTranslation('STR_WPT_LOGON_ERROR_MSG');
                        this._errorMessage = msgPrefix + ": " + data.Connection.Message;
                    }
                    else {
                        this._errorMessage = null;
                    }
                    if (this._usingIdP) {
                        let warningFn = this._core.Helper.presentWarningServiceModal.bind(this, "STR_WPT_LOGON", "STR_WPT_ERROR", this._errorMessage, this.idpLogout);
                        this._core.Helper.closeIdPBusyModal(warningFn);
                    }
                    else {
                        this._core.Functions.hideElement(this._processingDiv);
                        this._core.Functions.showElement(this._failToLogonInfo);
                        this._core.Functions.showElement(this._failToLogon);
                        this._prepareLogonModalInput(true);
                    }
                };
                this._displayLogonErrorMessage = () => {
                    this._log.info("LogonNavigationHandler._displayLogonErrorMessage()");
                    if (this._errorMessage != null) {
                        this._core.Helper.presentWarningModal(this._errorMessage);
                    }
                };
                this._startContactVerification = () => {
                    this._log.info("LogonNavigationHandler._startContactVerification()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/ValidateContactCheck/' + this._currentValidationKey, this._startValidationModal, this._errorValidation, this._failedValidation, true);
                };
                this._presentActivationModal = () => {
                    this._log.info("LogonNavigationHandler._presentActivationModal()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/CreateAccountCheck/' + this._currentActivationKey, this._startActivationModal, this._errorActivation, this._failedActivation, true);
                };
                this._errorActivation = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._errorActivation()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_ACCOUNT_CHECK_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CREATEACCOUNT", "STR_WPT_ERROR", msgBody);
                };
                this._failedActivation = (response) => {
                    this._log.info("LogonNavigationHandler._failedActivation()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_ACCOUNT_CHECK_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        errorMsg += response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._startActivationModal = () => {
                    this._log.info("LogonNavigationHandler._startActivationModal()");
                    let modalSession = 'activation-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentActivationModalSession = modalSession;
                        if (this._activationHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/CreateAccountPasswordModal.html', this._storeActivationHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._finishActivationModal();
                        }
                    }
                    else {
                        console.error("unable to show activation modal, modal placeholder is already used");
                    }
                };
                this._storeActivationHtml = (htmlData) => {
                    this._log.info("LogonNavigationHandler._storeActivationHtml()");
                    this._activationHtml = htmlData;
                    this._finishActivationModal();
                };
                this._finishActivationModal = () => {
                    var _a, _b, _c;
                    this._log.info("LogonNavigationHandler._finishActivationModal()");
                    let modal = this._core.getModal(this._currentActivationModalSession);
                    modal.DIV.innerHTML = this._activationHtml;
                    this._activateAccountBtn = modal.DIV.querySelector('#createAccountButton');
                    this._passwordInput = modal.DIV.querySelector('#createAccountPasswordTextbox');
                    this._reenterPwdInput = modal.DIV.querySelector('#reenterCreateAccountPasswordTextbox');
                    this._processingDiv = modal.DIV.querySelector('.wpt-hourglass');
                    this._core.Helper.prepareHourglassIcon(this._processingDiv);
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#createAccountModalTitle'), 'STR_WPT_CREATEOBACCOUNT');
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', 'STR_WPT_CLOSE');
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', 'STR_WPT_CLOSE');
                    this._core.Helper.setElementTranslation(this._activateAccountBtn, 'STR_WPT_CREATEACCOUNT');
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'placeholder', "STR_WPT_ENTERPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'aria-label', "STR_WPT_ENTERPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._reenterPwdInput, 'placeholder', "STR_WPT_REENTERPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._reenterPwdInput, 'aria-label', "STR_WPT_REENTERPASSWORD");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#processingLabel'), "STR_WPT_PROCESSING");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (((_a = appConfig.Content) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('PasswordInfoText')) && ((_b = appConfig.Content) === null || _b === void 0 ? void 0 : _b.PasswordInfoText.length) > 0) {
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#createAccountInfoText'), (_c = appConfig.Content) === null || _c === void 0 ? void 0 : _c.PasswordInfoText);
                        this._core.Functions.showElement(modal.DIV.querySelector('#createAccountInfoTextDiv'));
                    }
                    this._activateAccountBtn.addEventListener('click', this._activateAccount);
                    this._passwordInput.addEventListener('keydown', this._activationKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._activationKeyHandler);
                    modal.DIV.querySelector('#createAccountPasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._passwordInput));
                    modal.DIV.querySelector('#reenterCreateAccountPasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._reenterPwdInput));
                    this._waitForServerPing().then(this._showActivationModal);
                };
                this._showActivationModal = () => {
                    this._log.info("LogonNavigationHandler._showActivationModal()");
                    let logon = this;
                    let modal = this._core.getModal(this._currentActivationModalSession);
                    modal.JQ.one('shown.bs.modal', function () {
                        logon._passwordInput.focus();
                    });
                    this._passwordInput.focus();
                    this._core.showModal(this._currentActivationModalSession);
                };
                this._activationKeyHandler = (event) => {
                    this._log.info("LogonNavigationHandler._activationKeyHandler()");
                    if (event.key === "Enter") {
                        event.preventDefault();
                        this._activateAccount(null);
                    }
                };
                this._activateAccount = (event) => {
                    this._log.info("LogonNavigationHandler._activateAccount()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    let password = this._passwordInput.value;
                    let reenterPwd = this._reenterPwdInput.value;
                    if (password === '') {
                        this._passwordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._passwordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (reenterPwd === '') {
                        this._reenterPwdInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._reenterPwdInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (password != '' && reenterPwd != '' && password === reenterPwd) {
                        this._passwordInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._reenterPwdInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._activateAccountBtn.disabled = true;
                        this._passwordInput.removeEventListener('keydown', this._activationKeyHandler);
                        this._reenterPwdInput.removeEventListener('keydown', this._activationKeyHandler);
                        this._core.Functions.showElement(this._processingDiv);
                        let user = {
                            Key: this._currentActivationKey,
                            Password: password,
                            Username: null,
                            UserGroups: []
                        };
                        this._core.Loader.genericServiceCallWithData('/User.svc/rest/CreateAccountStage3', JSON.stringify(user), this._successfulActivation, null, this._activationError, this._activationFailed, true);
                    }
                    else {
                        console.warn("password needs to be provided two times and they have to match");
                        this._passwordInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._reenterPwdInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._core.Helper.presentWarningModal("STR_WPT_PASSWORDS_NOT_MATCHING");
                    }
                };
                this._successfulActivation = (response) => {
                    this._log.info("LogonNavigationHandler._successfulActivation()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created user: " + response.User.Username);
                    }
                    this._currentActivationKey = null;
                    let logon = this;
                    let modal = logon._core.getModal(logon._currentActivationModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        logon._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_NEW_ACCOUNT_CREATED');
                    });
                    this._core.hideModal(logon._currentActivationModalSession);
                };
                this._activationError = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._activationError()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._activateAccountBtn.disabled = false;
                    this._passwordInput.addEventListener('keydown', this._activationKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._activationKeyHandler);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CREATEACCOUNT_ACTIVATION_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CREATEACCOUNT", "STR_WPT_ERROR", msgBody);
                };
                this._activationFailed = (response) => {
                    this._log.info("LogonNavigationHandler._activationFailed()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._activateAccountBtn.disabled = false;
                    this._passwordInput.addEventListener('keydown', this._activationKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._activationKeyHandler);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CREATEACCOUNT_ACTIVATION_ERROR_MSG');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(msgBody);
                };
                this._errorValidation = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._errorValidation()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_ACCOUNT_VERIFY_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_VERIFYCONTACT", "STR_WPT_ERROR", msgBody);
                };
                this._failedValidation = (response) => {
                    this._log.info("LogonNavigationHandler._failedValidation()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_ACCOUNT_VERIFY_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        errorMsg += response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._startValidationModal = (response) => {
                    this._log.info("LogonNavigationHandler._startValidationModal()");
                    // If we've got here, we have a successful verification
                    this._currentValidationKey = null;
                    this._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_CONTACT_VERIFIED', 'STR_WPT_VERIFYCONTACT');
                };
                this._forgotPassword = (event = null) => {
                    this._log.info("LogonNavigationHandler._forgotPassword()");
                    if (event)
                        event.preventDefault(); // prevent sending of form (would reload the page)
                    let username = this._forgotPwUserInput.value;
                    if (username === '') {
                        this._forgotPwUserInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._forgotPwUserInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._core.Functions.showElement(this._processingDiv);
                        this._core.Loader.genericServiceCall('/User.svc/rest/ForgotPassword/' + username, this._forgotPwRequested, this._forgotPwError, this._forgtoPwFailed, true);
                    }
                };
                this._forgotPwRequested = () => {
                    this._log.info("LogonNavigationHandler._forgotPwRequested()");
                    this._core.Functions.clearInputElement(this._forgotPwUserInput);
                    let logon = this;
                    let modal = logon._core.getModal(logon._currentForgotPwModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        logon._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_FORGOTPW_REQUESTED');
                    });
                    this._core.hideModal(logon._currentForgotPwModalSession);
                };
                this._forgotPwError = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._forgotPwError()");
                    this._hideLoader();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_SUBMIT_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_FORGOTPASSWORD", "STR_WPT_ERROR", msgBody);
                };
                this._forgtoPwFailed = (response) => {
                    this._log.info("LogonNavigationHandler._forgtoPwFailed()");
                    this._hideLoader();
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_SUBMIT_ERROR_MSG');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningServiceModal("STR_WPT_FORGOTPASSWORD", "STR_WPT_ERROR", msgBody);
                };
                this.checkValidationHash = (validationHash) => {
                    this._log.info("LogonNavigationHandler.checkValidationHash()");
                    if (!this._supportPasswordValidation)
                        return false;
                    else
                        return (validationHash === this._userValidationHash);
                };
                this._startForgotPwModal = () => {
                    this._log.info("LogonNavigationHandler._startForgotPwModal()");
                    if (this._forgotPwHtml === null) {
                        this._core.Loader.getVersionedHTML('assets/wpt/html/ForgotPasswordModal.html', this._storeForgotPwHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    else {
                        this._finishForgotPwModal();
                    }
                };
                this._storeForgotPwHtml = (htmlData) => {
                    this._log.info("LogonNavigationHandler._storeForgotPwHtml()");
                    this._forgotPwHtml = htmlData;
                    this._finishForgotPwModal();
                };
                this._finishForgotPwModal = () => {
                    this._log.info("LogonNavigationHandler._finishForgotPwModal()");
                    let modal = this._core.getModal(this._currentForgotPwModalSession);
                    modal.DIV.innerHTML = this._forgotPwHtml;
                    this._forgotPwBtn = modal.DIV.querySelector('#forgotPwButton');
                    this._forgotPwUserInput = modal.DIV.querySelector('#forgotPwUserTextbox');
                    this._processingDiv = modal.DIV.querySelector('.wpt-hourglass');
                    this._core.Helper.prepareHourglassIcon(this._processingDiv);
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#forgotPwModalTitle'), "STR_WPT_FORGOTPASSWORD");
                    this._core.Helper.setElementTranslation(this._forgotPwBtn.querySelector('#forgotPwButtonLabel'), "STR_WPT_FORGOTPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._forgotPwUserInput, 'placeholder', "STR_WPT_ENTERUSERNAME");
                    this._core.Helper.setElementTranslationAttribute(this._forgotPwUserInput, 'aria-label', "STR_WPT_ENTERUSERNAME");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#processingLabel'), "STR_WPT_PROCESSING");
                    this._forgotPwBtn.addEventListener('click', this._forgotPassword);
                    modal.DIV.querySelector('#forgotPwUserClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._forgotPwUserInput));
                    this._showForgotPwModal();
                };
                this._showForgotPwModal = () => {
                    this._log.info("LogonNavigationHandler._showForgotPwModal()");
                    let logon = this;
                    let modal = this._core.getModal(this._currentForgotPwModalSession);
                    modal.JQ.one('shown.bs.modal', function () {
                        logon._forgotPwUserInput.focus();
                    });
                    this._forgotPwUserInput.focus();
                    this._core.showModal(this._currentForgotPwModalSession);
                };
                this._presentResetPwModal = () => {
                    this._log.info("LogonNavigationHandler._presentResetPwModal()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/ForgotPasswordCheck/' + this._currentForgotPwKey, this._startResetPwModal, this._errorResetPw, this._failedResetPw, true);
                };
                this._errorResetPw = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._errorResetPw()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_CHECK_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_FORGOTPASSWORD", "STR_WPT_ERROR", msgBody);
                };
                this._failedResetPw = (response) => {
                    this._log.info("LogonNavigationHandler._failedResetPw()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_CHECK_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message') && response.Connection.Message.length > 0) {
                        errorMsg += response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._startResetPwModal = () => {
                    this._log.info("LogonNavigationHandler._startResetPwModal()");
                    let modalSession = 'reset-pw-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentResetPwModalSession = modalSession;
                        if (this._resetPwHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/ResetPasswordModal.html', this._storeResetPwHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._finishResetPwModal();
                        }
                    }
                    else {
                        console.error("unable to show reset password modal, modal placeholder is already used");
                    }
                };
                this._storeResetPwHtml = (htmlData) => {
                    this._log.info("LogonNavigationHandler._storeResetPwHtml()");
                    this._resetPwHtml = htmlData;
                    this._finishResetPwModal();
                };
                this._finishResetPwModal = () => {
                    var _a, _b, _c;
                    this._log.info("LogonNavigationHandler._finishResetPwModal()");
                    let modal = this._core.getModal(this._currentResetPwModalSession);
                    modal.DIV.innerHTML = this._resetPwHtml;
                    this._resetForgottenPwBtn = modal.DIV.querySelector('#resetPwButton');
                    this._passwordInput = modal.DIV.querySelector('#resetPasswordTextbox');
                    this._reenterPwdInput = modal.DIV.querySelector('#reenterResetPasswordTextbox');
                    this._processingDiv = modal.DIV.querySelector('.wpt-hourglass');
                    this._core.Helper.prepareHourglassIcon(this._processingDiv);
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#resetPwModalTitle'), 'STR_WPT_FORGOTPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'title', 'STR_WPT_CLOSE');
                    this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), 'aria-label', "STR_WPT_CLOSE");
                    this._core.Helper.setElementTranslation(this._resetForgottenPwBtn, 'STR_WPT_RESETPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'placeholder', "STR_WPT_ENTERPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._passwordInput, 'aria-label', 'STR_WPT_ENTERPASSWORD');
                    this._core.Helper.setElementTranslationAttribute(this._reenterPwdInput, 'placeholder', "STR_WPT_REENTERPASSWORD");
                    this._core.Helper.setElementTranslationAttribute(this._reenterPwdInput, 'aria-label', 'STR_WPT_REENTERPASSWORD');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#processingLabel'), "STR_WPT_PROCESSING");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (((_a = appConfig.Content) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('PasswordInfoText')) && ((_b = appConfig.Content) === null || _b === void 0 ? void 0 : _b.PasswordInfoText.length) > 0) {
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#resetPwInfoText'), (_c = appConfig.Content) === null || _c === void 0 ? void 0 : _c.PasswordInfoText);
                        this._core.Functions.showElement(modal.DIV.querySelector('#resetPwInfoTextDiv'));
                    }
                    this._resetForgottenPwBtn.addEventListener('click', this._resetForgottenPw);
                    this._passwordInput.addEventListener('keydown', this._resetPwKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._resetPwKeyHandler);
                    modal.DIV.querySelector('#resetPasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._passwordInput));
                    modal.DIV.querySelector('#reenterResetPasswordClearTextbox').addEventListener('click', this._core.Functions.clearAndFocusInputElement.bind(this, this._reenterPwdInput));
                    this._waitForServerPing().then(this._showResetPwModal);
                };
                this._showResetPwModal = () => {
                    this._log.info("LogonNavigationHandler._showResetPwModal()");
                    let logon = this;
                    let modal = this._core.getModal(this._currentResetPwModalSession);
                    modal.JQ.one('shown.bs.modal', function () {
                        logon._passwordInput.focus();
                    });
                    this._passwordInput.focus();
                    this._core.showModal(this._currentResetPwModalSession);
                };
                this._resetPwKeyHandler = (event) => {
                    this._log.info("LogonNavigationHandler._resetPwKeyHandler()");
                    if (event.key === "Enter") {
                        event.preventDefault();
                        this._resetForgottenPw(null);
                    }
                };
                this._resetForgottenPw = (event) => {
                    this._log.info("LogonNavigationHandler._resetForgottenPw()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    let password = this._passwordInput.value;
                    let reenterPwd = this._reenterPwdInput.value;
                    if (password === '') {
                        this._passwordInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._passwordInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (reenterPwd === '') {
                        this._reenterPwdInput.classList.add(Navigation.REQUIRED_CLASS);
                    }
                    else {
                        this._reenterPwdInput.classList.remove(Navigation.REQUIRED_CLASS);
                    }
                    if (password != '' && reenterPwd != '' && password === reenterPwd) {
                        this._passwordInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._reenterPwdInput.classList.remove(Navigation.REQUIRED_CLASS);
                        this._resetForgottenPwBtn.disabled = true;
                        this._passwordInput.removeEventListener('keydown', this._resetPwKeyHandler);
                        this._reenterPwdInput.removeEventListener('keydown', this._resetPwKeyHandler);
                        this._core.Functions.showElement(this._processingDiv);
                        let user = {
                            Key: this._currentForgotPwKey,
                            Password: password,
                            Username: null,
                            UserGroups: []
                        };
                        this._core.Loader.genericServiceCallWithData('/User.svc/rest/ResetForgotPassword', JSON.stringify(user), this._successfulResetForgottenPw, null, this._resetForgottenPwError, this._resetForgottenPwFailed, true);
                    }
                    else {
                        console.warn("password needs to be provided two times and they have to match");
                        this._passwordInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._reenterPwdInput.classList.add(Navigation.REQUIRED_CLASS);
                        this._core.Helper.presentWarningModal("STR_WPT_PASSWORDS_NOT_MATCHING");
                    }
                };
                this._successfulResetForgottenPw = (response) => {
                    this._log.info("LogonNavigationHandler._successfulResetForgottenPw()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("reset password for user: " + response.User.Username);
                    }
                    this._currentForgotPwKey = null;
                    let logon = this;
                    let modal = logon._core.getModal(logon._currentResetPwModalSession);
                    modal.JQ.one('hidden.bs.modal', function () {
                        logon._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_UPDATEDPASSWORD');
                    });
                    this._core.hideModal(logon._currentResetPwModalSession);
                };
                this._resetForgottenPwError = (url, status, text) => {
                    this._log.info("LogonNavigationHandler._resetForgottenPwError()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._resetForgottenPwBtn.disabled = false;
                    this._passwordInput.addEventListener('keydown', this._resetPwKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._resetPwKeyHandler);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_FORGOTPASSWORD", "STR_WPT_ERROR", msgBody);
                };
                this._resetForgottenPwFailed = (response) => {
                    this._log.info("LogonNavigationHandler._resetForgottenPwFailed()");
                    this._core.Functions.hideElement(this._processingDiv);
                    this._resetForgottenPwBtn.disabled = false;
                    this._passwordInput.addEventListener('keydown', this._resetPwKeyHandler);
                    this._reenterPwdInput.addEventListener('keydown', this._resetPwKeyHandler);
                    let errorMsg = this._core.Locale.getTranslation('STR_WPT_FORGOTPW_ERROR_MSG');
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message') && response.Connection.Message.length > 0) {
                        errorMsg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._checkIdPLogon = (callback) => {
                    this._log.info("LogonNavigationHandler._checkIdPLogon()");
                    // Shouldn't get here with no IdP config
                    if (!this._oidcMgr) {
                        this._log.info("LogonNavigationHandler._checkIdPLogon() called with no valid oidc manager.");
                        return;
                    }
                    // Are we already logged in? Check with binding
                    this._oidcMgr.getUser().then(callback);
                };
                this._idpExecuteNextLoginStep = (user) => {
                    this._log.info("LogonNavigationHandler._idpExecuteNextLoginStep()");
                    if (user) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("IdP enabled, user successfully authenticated - starting next steps...");
                        }
                        this._usingIdP = true;
                        // Present busy modal
                        this._core.Helper.presentIdPBusyModal('STR_WPT_CONNECTING_ONBASE');
                        this._core.logonIdP(user.access_token, this._successfulLogon, this._errorLogon, this._failedLogon);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("IdP enabled, user not currently logged in - logging in...");
                        }
                        this._usingIdP = true;
                        this._idpLogonInitialConnect();
                    }
                };
                // Does nothing if we don't have a valid IdP user record
                this._idpExecuteOnBaseLoginIfReady = (user) => {
                    this._log.info("LogonNavigationHandler._idpExecuteOnBaseLoginIfReady()");
                    if (user) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("IdP enabled, user successfully authenticated - starting next steps...");
                        }
                        this._usingIdP = true;
                        // Present busy modal
                        this._core.Helper.presentIdPBusyModal('STR_WPT_CONNECTING_ONBASE');
                        this._core.logonIdP(user.access_token, this._successfulLogon, this._errorLogon, this._failedLogon);
                    }
                };
                this._idpLogonInitialConnect = () => {
                    this._log.info("LogonNavigationHandler._idpLogonInitialConnect()");
                    // Present busy modal - this will go away when we redirect to IdP
                    this._core.Helper.presentIdPBusyModal('STR_WPT_CONNECTING_IDP');
                    // Store our state info
                    let storageKey = `WPT-IdP-${Date.now().toString()}`;
                    localStorage.setItem(storageKey, window.location.search);
                    // Actually attempt login
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("attempting login!");
                    }
                    this._oidcMgr.signinRedirect({ state: storageKey });
                };
                this.idpLogout = () => {
                    this._log.info("LogonNavigationHandler.idpLogout()");
                    if (this._oidcMgr)
                        this._oidcMgr.getUser().then((user) => {
                            let idpConfig = this._core.Config.getMainConfig().IdP;
                            if (this._retainQueryStringAtLogout)
                                localStorage.setItem('WPT-IdP-Logout-QueryString', window.location.search);
                            this._oidcMgr.signoutRedirect({
                                id_token_hint: user && user.id_token,
                                post_logout_redirect_uri: idpConfig.PostLogoutRedirect
                            }).then((value) => {
                                this._oidcMgr.removeUser();
                            });
                        });
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LogonNavigationHandler::constructor");
                // Check if we need to support password validation, and if so load the appropriate code
                let config = core.Config.getMainConfig();
                if (config.hasOwnProperty("SupportPasswordValidation") && (config.SupportPasswordValidation == true)) {
                    this._supportPasswordValidation = true;
                    core.Loader.loadVersionedJS("./assets/jshash-2.2/sha512-min.js", null);
                }
                this._logonPage = document.getElementById('logonPage');
                // Check for oidc/IdP support
                if (this.UsingIdP) {
                    let idpConfig = this._core.Config.getMainConfig().IdP;
                    if (idpConfig.hasOwnProperty('RetainQueryStringAtLogout') && (idpConfig.RetainQueryStringAtLogout != null))
                        this._retainQueryStringAtLogout = idpConfig.RetainQueryStringAtLogout;
                    let umConfig = {
                        authority: idpConfig.Authority,
                        client_id: idpConfig.ClientId,
                        redirect_uri: idpConfig.ReturnRedirect,
                        response_type: idpConfig.ResponseType,
                        scope: idpConfig.Scope,
                        post_logout_redirect_uri: idpConfig.PostLogoutRedirect
                    };
                    // Create the object
                    Oidc.Log.logger = console;
                    this._oidcMgr = new Oidc.UserManager(umConfig);
                }
            }
            get UsingIdP() {
                this._log.info("LogonNavigationHandler.UsingIdP()");
                let gwConfig = this._core.Config.getMainConfig();
                return (gwConfig.hasOwnProperty('IdP') && gwConfig.IdP && gwConfig.IdP.hasOwnProperty('Enabled') && gwConfig.IdP.Enabled);
            }
            get SupportPasswordValidation() {
                this._log.info("LogonNavigationHandler.SupportPasswordValidation()");
                return this._supportPasswordValidation;
            }
        }
        Navigation.LogonNavigationHandler = LogonNavigationHandler;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
